import { render, staticRenderFns } from "./PaymentsRetail.vue?vue&type=template&id=01c52730&scoped=true&"
import script from "./PaymentsRetail.vue?vue&type=script&lang=js&"
export * from "./PaymentsRetail.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsRetail.vue?vue&type=style&index=0&id=01c52730&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c52730",
  null
  
)

export default component.exports